// extracted by mini-css-extract-plugin
export default {"container":"sort_location_container__BJX3T"};